import axios from "./customapi";
import { env } from "../env";

const REQUEST_ID = env.REACT_APP_REQUESTID;

export const fetchBanner = () => {
  return axios.post("banner/getAll", {
    requestId: REQUEST_ID,
  });
};

export const fetchNew = (idn, categoryId, page, size) => {
  return axios.post("news/getNews", {
    requestId: REQUEST_ID,
    id: idn || "",
    categoryId: categoryId,
    page: page,
    size: size,
  });
};

export const fetchIntroduce = () => {
  return axios.post("news/getNews", {
    requestId: REQUEST_ID,
    id: null,
    categoryId: 388,
    page: null,
    size: 1000,
  });
};

export const fetchIntro = () => {
  return axios.post("news/getNews", {
    requestId: REQUEST_ID,
    id: null,
    categoryId: 389,
    page: null,
    size: 1000,
  });
};

export const fetchStruc = () => {
  return axios.post("news/getNews", {
    requestId: REQUEST_ID,
    id: null,
    categoryId: 390,
    page: null,
    size: 1000,
  });
};

export const fetchInfraStruc = () => {
  return axios.post("news/getNews", {
    requestId: REQUEST_ID,
    id: null,
    categoryId: 391,
    page: null,
    size: 1000,
  });
};

export const fetchVideo = () => {
  return axios.post("video/getVideo", {
    requestId: REQUEST_ID,
    size: 1000,
  });
};

export const fetchMenu = () => {
  return axios.post("category/getAll", {
    requestId: REQUEST_ID,
  });
};

export const fetchImage = () => {
  return axios.post("image/getImage", {
    requestId: REQUEST_ID,
    size: 1000,
  });
};

export const fetchNewOn = () => {
  return axios.post("news/getNews", {
    requestId: REQUEST_ID,
    id: null,
    categoryId: 394,
    page: null,
    size: 1000,
  });
};

export const fetchService = (data) => {
  return axios.post("news/getNews", {
    requestId: REQUEST_ID,
    id: null,
    categoryId: 381,
    page: data.page || 1,
    size: data.size || null,
  });
};

export const submitTuVan = (payload) => {
  return axios.post("tu-van/register", {
    requestId: REQUEST_ID,
    ...payload,
  });
};

export const fetchSearch = (data) => {
  return axios.post("news/getNews", {
    requestId: REQUEST_ID,
    id: data.id,
    categoryId: null,
    page: data.page,
    size: 10,
    title: data.key,
  });
};
